import { Image, UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';

import chartImg from './assets/chart.svg';
import homeImg from './assets/home.svg';
import ratingImg from './assets/rating.svg';
import womanImg from './assets/woman.svg';
import * as styles from './styles.css';

export function AboutReportDesktop() {
  return (
    <section data-testid="AboutReportDesktop" className={styles['container']}>
      <div className={styles['title-box']}>
        <div className={styles['title']}>
          <UIHeading1 as="h3">Что будет в отчёте</UIHeading1>
        </div>
        <div className={styles['title-img']}>
          <Image src={womanImg} />
        </div>
      </div>
      <div className={styles['chart']}>
        <div className={styles['chart_title']}>
          <UIHeading1 as="h3">График изменения цены</UIHeading1>
        </div>
        <div className={styles['chart_img']}>
          <Image src={chartImg} />
        </div>
      </div>
      <div className={styles['rating']}>
        <div className={styles['rating_title']}>
          <UIHeading1 as="h3">Средняя оценка и диапазон цен</UIHeading1>
        </div>
        <div className={styles['rating_img']}>
          <Image src={ratingImg} />
        </div>
      </div>
      <div className={styles['home']}>
        <UIHeading1 as="h3">Информация о доме</UIHeading1>
        <div className={styles['home_img']}>
          <Image src={homeImg} />
        </div>
      </div>
    </section>
  );
}
